export enum NotificationType {
  SUCCESS = 'success',
  INFO = 'info',
  ERROR = 'error',
}
